type FormErrors = Record<string, string>;

export const validateRegisterForm = (formData: {
  email: string;
  password: string;
  confirmPassword: string;
  verificationCode: string;
}): { isValid: boolean; errors: FormErrors } => {
  const errors: FormErrors = {};
  
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Email is invalid";
  }
  
  if (!formData.password) {
    errors.password = "Password is required";
  } else if (formData.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }
  
  if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  if (!formData.verificationCode.trim()) {
    errors.verificationCode = "Verification code is required";
  }
  
  return { 
    isValid: Object.keys(errors).length === 0,
    errors 
  };
};

export const validateLoginForm = (formData: {
  email: string;
  password: string;
}): FormErrors => {
  const errors: FormErrors = {};
  
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Email is invalid";
  }
  
  if (!formData.password) {
    errors.password = "Password is required";
  } else if (formData.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }
  
  return errors;
};
